import { render, staticRenderFns } from "./pet-exercise-component.vue?vue&type=template&id=44159869&scoped=true&lang=pug"
import script from "./pet-exercise-component.js?vue&type=script&lang=js&external"
export * from "./pet-exercise-component.js?vue&type=script&lang=js&external"
import style0 from "./pet-exercise-component.vue?vue&type=style&index=0&id=44159869&prod&lang=scss&scoped=true"
import style1 from "./pet-exercise-component.vue?vue&type=style&index=1&id=44159869&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44159869",
  null
  
)

export default component.exports